export const D4_MYTHIC_AFFIXES = [
        "+1 Set count to Applied Alchemy",
        "+1 Set count to Arms of Arreat",
        "+1 Set count to Art of the Bone Weaver",
        "+1 Set count to Balazan's Bite",
        "+1 Set count to Berserker's Crucible",
        "+1 Set count to Bliss of the Multitude",
        "+1 Set count to Bloodletter's Flow",
        "+1 Set count to Breath of Frozen Sea",
        "+1 Set count to Bul-Kathos' Pride",
        "+1 Set count to Cain's Wild Lightning",
        "+1 Set count to Cathan's Dauntless Faith",
        "+1 Set count to Cathan's Iron Conviction",
        "+1 Set count to Cathan's Righteous Will",
        "+1 Set count to Dark Pact",
        "+1 Set count to Flesh of Abbadon",
        "+1 Set count to Fulcrum of Mefis",
        "+1 Set count to Habacalva's Cauldron",
        "+1 Set count to Heaven's Radiant Fire",
        "+1 Set count to Horazon's Chains",
        "+1 Set count to Kwatli's Grace",
        "+1 Set count to Legacy of the Sightless",
        "+1 Set count to Light's Epiphany",
        "+1 Set count to Mastery",
        "+1 Set count to Might of the Den Mother",
        "+1 Set count to Nafain's Bestiary",
        "+1 Set count to Nilfur's Narrow Eye",
        "+1 Set count to Peace of the Black Shroud",
        "+1 Set count to Practiced Technique",
        "+1 Set count to Radament's Desecration",
        "+1 Set count to Rathma's Waking Touch",
        "+1 Set count to Rezoka's Rage",
        "+1 Set count to Ritual of the Nameless",
        "+1 Set count to Rush of the Red Wolf Moon",
        "+1 Set count to Sescheron's Fury",
        "+1 Set count to Shadow of Harash",
        "+1 Set count to Slaughter",
        "+1 Set count to Song of the Old Mountain",
        "+1 Set count to Spellbound Steel",
        "+1 Set count to Storm Shepherd's Call",
        "+1 Set count to Survival",
        "+1 Set count to Tal Rasha's Threefold Way",
        "+1 Set count to Tiraj's Uncanny Insight",
        "+1 Set count to Unlocks X_0 Charm Slots",
        "+1 Set count to Way of the Blurring Blade",
        "+1 Set count to Word of the Blood Binder",
        "+1 Set count to Wumba's Embrace"
    ]
;


